import { Checkbox, Popover } from "antd";
import React, { useState } from "react";
import AlertIcon from "../../../../Common/Svgs/AlertIcon";
import ChevronIcon from "../../../../Common/Svgs/ChevronIcon";

const SelectSwapBatteries = ({
  onSelect,
  hasError,
  tripBatteryIds,
  selectedBatteryIds,
}) => {
  const [open, setOpen] = useState(false);

  const hasValues = selectedBatteryIds.length > 0;

  const getValueContainerClassName = () => {
    if (hasError) return "border-alert-red";
    if (open) return "border-primary";
    return "border-light-grey";
  };

  const getLabelText = () => {
    if (!selectedBatteryIds.length) return "Select batteries for swap";

    if (selectedBatteryIds.length === 1) return "1 battery selected";

    return `${selectedBatteryIds.length} batteries selected`;
  };

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open}
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div>
          {tripBatteryIds.length ? (
            <div
              className="bg-background-white py-1 px-3 rounded-md
              max-h-[500px] overflow-y-scroll"
              style={{ width: "367px" }}
            >
              {tripBatteryIds.map((item) => {
                const selected = selectedBatteryIds.includes(item.id);
                return (
                  <button
                    key={item.id}
                    type="button"
                    className="py-2 flex items-center gap-x-3 w-full"
                    onClick={() => onSelect(item.id)}
                  >
                    <Checkbox checked={selected} />

                    <p
                      className={`font-aileron font-semibold text-xs capitalize ${
                        selected ? "text-black" : "text-dark-gray"
                      }`}
                    >
                      {item.value}
                    </p>
                  </button>
                );
              })}
            </div>
          ) : null}
        </div>
      }
    >
      <button
        type="button"
        className={`px-3.5 py-2 w-[367px] bg-white flex items-center justify-between gap-x-3 rounded-md border ${getValueContainerClassName()}`}
      >
        <div>
          <p
            className={`font-aileron font-normal text-xs ${
              hasValues ? "text-black" : "text-dark-grey-text"
            }`}
          >
            {getLabelText()}
          </p>
        </div>

        {hasError ? (
          <AlertIcon className="text-alert-red" />
        ) : (
          <ChevronIcon
            className={`w-5 h-5 stroke-dark-gray
           ${open ? "-rotate-90" : "rotate-90"}`}
            strokeWidth="1"
          />
        )}
      </button>
    </Popover>
  );
};

export default SelectSwapBatteries;
